<template>
  <button v-if="!helpTextIsActive" type="button" class="help-text-icon-button" @click="toggleHelpText">
    <IconInfoCircleFilled class="help-text-icon" />
  </button>
  <button v-if="helpTextIsActive" type="button" class="help-text-icon-button active" @click="toggleHelpText">
    <IconCircleXFilled class="help-text-icon" />
  </button>

  <div class="core-sidebar" :class="helpTextIsActive ? 'open' : 'close'">
    <div class="py-6 md:py-12 overflow-x-hidden h-full">
      <h2 v-if="content?.title" class="text-xl px-4 mr-12 md:px-12 w-100 lg:w-[48rem]">{{ content.title }}</h2>
      <div v-if="content?.body" class="core-wysiwyg px-4 md:px-12 mt-6 w-100 lg:w-[48rem]" v-html="content.body"></div>
      <div v-if="!content" class="px-12 w-[32rem]">{{ $t('general.content_not_found') }}</div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed, ref } from 'vue'
import { IconCircleXFilled, IconInfoCircleFilled } from '@tabler/icons-vue'
import { useContentStore } from '@/stores/content'

const props = defineProps<{
  slug: string
  role?: string
}>()

const contentStore = useContentStore()
const helpTextIsActive = ref(false)

const content = computed(() => {
  return contentStore.getHelpText(props.slug, props.role) as { title: string; body: string }
})

function toggleHelpText() {
  helpTextIsActive.value = !helpTextIsActive.value
}
</script>

<style lang="postcss">
.help-text-icon-button {
  @apply absolute top-6 lg:top-12 right-4 sm:right-8 z-[21] inline-flex h-6 w-6 cursor-pointer items-center justify-center;
  @apply border-0 bg-transparent p-0;
  @apply appearance-none;
  @apply focus-visible:outline-none;

  &::before {
    content: '';
    @apply absolute left-1/2 top-1/2 h-4 w-4 -translate-x-1/2 -translate-y-1/2 rounded-full bg-white;
  }

  .help-text-icon {
    @apply relative z-[1] block h-6 w-6 text-neutral-600;
  }

  &:hover,
  &.active {
    .help-text-icon {
      @apply text-primary-default;
    }
  }
}
.core-sidebar {
  @apply absolute inset-y-0 right-0 hidden z-20;
  @apply border-l border-neutral-300 bg-white;
  box-shadow:
    -1px 0 3px rgba(0, 0, 0, 0.06),
    -5px 0 10px -2px rgba(0, 0, 0, 0.08);

  &.open {
    @apply w-[48rem] max-w-full block;
    animation: slide-in 0.5s;
  }
  &.close {
    animation: slide-out 0.5s;
  }
}

@keyframes slide-in {
  from {
    @apply w-0;
  }
  to {
    @apply w-[48rem] max-w-full;
  }
}
@keyframes slide-out {
  from {
    @apply block w-[48rem] max-w-full;
  }
  to {
    @apply hidden w-0;
  }
}
</style>
